export enum IdentificationFailureReason {
  OTHER = "other",
}
